'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.typed-array.find-last-index');



// WEBPACK FOOTER //
// ./~/core-js/modules/esnext.typed-array.find-last-index.js